// extracted by mini-css-extract-plugin
module.exports = {"criticalContainer":"Columns_criticalContainer__1mOEm","critical":"Columns_critical__3w6MS"};